"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "ServerErrorInterceptor", {
  enumerable: true,
  get: function get() {
    return _serverError.default;
  }
});
_Object$defineProperty(exports, "ServiceCatalog", {
  enumerable: true,
  get: function get() {
    return _serviceCatalog.default;
  }
});
_Object$defineProperty(exports, "ServiceHost", {
  enumerable: true,
  get: function get() {
    return _serviceHost.default;
  }
});
_Object$defineProperty(exports, "ServiceInterceptor", {
  enumerable: true,
  get: function get() {
    return _service.default;
  }
});
_Object$defineProperty(exports, "ServiceRegistry", {
  enumerable: true,
  get: function get() {
    return _serviceRegistry.default;
  }
});
_Object$defineProperty(exports, "ServiceState", {
  enumerable: true,
  get: function get() {
    return _serviceState.default;
  }
});
_Object$defineProperty(exports, "ServiceUrl", {
  enumerable: true,
  get: function get() {
    return _serviceUrl.default;
  }
});
_Object$defineProperty(exports, "Services", {
  enumerable: true,
  get: function get() {
    return _services.default;
  }
});
exports.constants = void 0;
var _webexCore = require("../../webex-core");
var constants = _interopRequireWildcard(require("./constants"));
exports.constants = constants;
var _services = _interopRequireDefault(require("./services"));
var _serverError = _interopRequireDefault(require("./interceptors/server-error"));
var _service = _interopRequireDefault(require("./interceptors/service"));
var _serviceCatalog = _interopRequireDefault(require("./service-catalog"));
var _serviceRegistry = _interopRequireDefault(require("./service-registry"));
var _serviceState = _interopRequireDefault(require("./service-state"));
var _serviceHost = _interopRequireDefault(require("./service-host"));
var _serviceUrl = _interopRequireDefault(require("./service-url"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('services', _services.default, {
  interceptors: {
    ServiceInterceptor: _service.default.create,
    ServerErrorInterceptor: _serverError.default.create
  }
});
//# sourceMappingURL=index.js.map
